module.exports = __webpack_public_path__ + "img/chevron_circle_gray.943d3339.svg";